import React from 'react'

import CenteredLayout from '../templates/CenteredLayout'
import LandingHeader from '../components/organisms/Landing/LandingHeader'
import ComeFunzionaContent from '../components/organisms/ComeFunzionaContent'
import SignupCTA from '../components/organisms/Landing/SignupCTA'
import LoggedOutFooter from '../components/organisms/Footer/LoggedOutFooter'

export default function Landing() {
  return (
    <CenteredLayout
      HeaderComp={<LandingHeader />}
      FooterComp={<LoggedOutFooter />}
      CtaComp={<SignupCTA />}
      style={{ paddingBottom: 0 }}
    >
      <ComeFunzionaContent marginTop />
    </CenteredLayout>
  )
}
